import { TelehealthSchedule } from "./types";

export const TIME_VALUE_REGEX = /^([01]\d|2[0-3]):[0-5]\d(:[0-5]\d)?$/;

export const toMinutes = (time: string | null | undefined): number | null => {
	if (!time || time === "-" || !TIME_VALUE_REGEX.test(time.trim())) return null;
	const [h, m] = time.trim().split(":").map(Number);
	return h * 60 + m;
};

export const formatTimeLabel = (time: string | null | undefined): string =>
	time ? time.substring(0, 5) : "--";

export const hasInvalidTimeRange = (schedule: TelehealthSchedule): boolean => {
	const start = toMinutes(schedule.startTime);
	const end = toMinutes(schedule.endTime);
	return start !== null && end !== null && end <= start;
};

export const hasMissingOrInvalidTime = (
	schedule: TelehealthSchedule
): boolean =>
	toMinutes(schedule.startTime) === null ||
	toMinutes(schedule.endTime) === null;

export const buildInvalidScheduleMessage = (
	schedules: TelehealthSchedule[],
	label: string
) => {
	if (schedules.length === 0) {
		return null;
	}

	const details = schedules
		.map(
			(schedule) =>
				`${schedule.dayOfWeek} (${formatTimeLabel(schedule.startTime)} - ${formatTimeLabel(schedule.endTime)})`
		)
		.join(", ");

	return `${label} must be after the start time for: ${details}.`;
};

export const buildMissingOrInvalidTimeMessage = (
	schedules: TelehealthSchedule[]
) => {
	if (schedules.length === 0) {
		return null;
	}

	const details = schedules
		.map((schedule) => `${schedule.dayOfWeek}`)
		.join(", ");

	return `Telehealth schedule start time and end time must be entered for: ${details}.`;
};
